export const MAP_PIN_TOGGLE_ERROR = 'Не удалось переключить состояние пина карты:';
export const MAP_CLUSTER_TOGGLE_ERROR =
  'Не удалось переключить состояние кластера карты:';
export const CATALOG_MORPHS_FETCH_ERROR = 'Ошибка получения морфов:';
export const CATALOG_DISTRICTS_FETCH_ERROR = 'Ошибка получения районов и метро:';
